import React, { Component } from 'react';
import { Button, Input, Modal } from 'antd';

class PasswordSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    };
  }

  handleOldPasswordChange(event) {
    this.setState({
      oldPassword: event.target.value,
    });
  }

  handleNewPasswordChange(event) {
    this.setState({
      newPassword: event.target.value,
    });
  }

  handleConfirmNewPasswordChange(event) {
    this.setState({
      confirmNewPassword: event.target.value,
    });
  }

  changePassword() {
    if (this.state.newPassword != this.state.confirmNewPassword) {
      this.setState({
        error: 'Passwords do not match',
      });
      return;
    }

    this.props.cognitoUser.changePassword(
      this.state.oldPassword,
      this.state.newPassword,
      (err, result) => {
        if (err) {
          this.setState({
            error: err,
          });
        } else {
          const modal = Modal.success({
            title: 'Password changed successfully',
          });
          setTimeout(() => modal.destroy(), 2000);

          this.setState({
            newPassword: '',
            oldPassword: '',
            confirmNewPassword: '',
          });
        }
      }
    );
  }

  render() {
    return (
      <div>
        <Input
          placeholder='Old Password'
          className='newPassword'
          type='password'
          onChange={this.handleOldPasswordChange.bind(this)}
          value={this.state.oldPassword}></Input>
        <Input
          placeholder='New Password'
          className='newPassword'
          type='password'
          onChange={this.handleNewPasswordChange.bind(this)}
          value={this.state.newPassword}></Input>
        <Input
          placeholder='Confirm New Password'
          className='newPassword'
          type='password'
          onChange={this.handleConfirmNewPasswordChange.bind(this)}
          value={this.state.confirmNewPassword}></Input>
        <Button id='newPasswordBtn' style={{ height: 35 }} onClick={this.changePassword.bind(this)}>
          {' '}
          Submit{' '}
        </Button>
        <p className='errorMessage'>{this.state.error}</p>
      </div>
    );
  }
}

export default PasswordSettings;



// WEBPACK FOOTER //
// ./src/components/userSettings/PasswordSettings.js